/*
  Plynne przesuwanie karuzel gladzikiem (dwa palce w lewo i prawo).

  Dlaczego nie wbudowany modul Swipera: jego "mousewheel" przeskakuje o cale
  slajdy, wiec gest wychodzi skokowy zamiast isc za palcami. Tutaj sumujemy
  przesuniecie z kolejnych zdarzen kolka i przesuwamy tasme dokladnie o tyle,
  ile dal gest, bez animacji. Dopiero gdy gest ucichnie, karuzela dosuwa sie
  do najblizszego slajdu.

  Nasluch jest delegowany na dokumencie, bo karuzele powstaja w roznych
  momentach (rekomendacje dociagaja sie zadaniem sieciowym), a niektore sa
  budowane i niszczone przy zmianie szerokosci okna.

  Reagujemy WYLACZNIE na przewazajacy ruch poziomy - inaczej przewijanie
  strony w dol nad karuzela zaczeloby ja przesuwac, bo gladzik przy kazdym
  gescie oddaje obie skladowe naraz.
*/
(() => {
  const KONIEC_GESTU = 110; // ms ciszy uznawanej za koniec gestu
  const DOSUNIECIE = 320; // ms animacji dosuwania do slajdu
  const stany = new WeakMap();

  const swiperElementu = (cel) => {
    const kontener = cel.closest?.(".swiper-container, .swiper");
    const swiper = kontener?.swiper;
    if (!swiper || swiper.destroyed) return null;
    if (swiper.isLocked) return null;
    if (swiper.params.direction !== "horizontal") return null;
    return swiper;
  };

  document.addEventListener(
    "wheel",
    (zdarzenie) => {
      if (zdarzenie.ctrlKey) return; // powiekszanie strony, nie nasza sprawa

      const poziom = zdarzenie.deltaX;
      const pion = zdarzenie.deltaY;
      if (Math.abs(poziom) <= Math.abs(pion)) return;
      if (Math.abs(poziom) < 1) return;

      const swiper = swiperElementu(zdarzenie.target);
      if (!swiper) return;

      const min = swiper.maxTranslate();
      const max = swiper.minTranslate();
      const teraz = swiper.getTranslate();

      // Na skrajnym slajdzie oddajemy gest stronie, zeby sie na nas nie zacinal.
      if ((teraz >= max && poziom < 0) || (teraz <= min && poziom > 0)) return;

      zdarzenie.preventDefault();

      const stan = stany.get(swiper) || {};
      clearTimeout(stan.timer);

      // Karuzela z autoodtwarzaniem nie moze szarpnac materialem pod palcami -
      // wstrzymujemy ja na czas gestu. Swiper robi to sam przy przeciaganiu,
      // ale my nie idziemy przez jego obsluge dotyku, wiec musimy jawnie.
      if (swiper.autoplay?.running && !swiper.autoplay.paused) {
        swiper.autoplay.pause();
        stan.wznowicAutoplay = true;
      }

      let docelowy = teraz - poziom;
      if (docelowy > max) docelowy = max;
      if (docelowy < min) docelowy = min;

      swiper.setTransition(0);
      swiper.setTranslate(docelowy);
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();

      stan.timer = setTimeout(() => {
        if (swiper.destroyed) return;
        swiper.slideToClosest(DOSUNIECIE);
        if (stan.wznowicAutoplay) {
          stan.wznowicAutoplay = false;
          swiper.autoplay?.resume();
        }
      }, KONIEC_GESTU);
      stany.set(swiper, stan);
    },
    { passive: false, capture: true },
  );
})();
